if (!customElements.get('range-products')) {
  const sync = (root, swiper) => {
    const canScroll = !swiper.isLocked
    root.classList.toggle('prd-RangeProducts--carousel', canScroll)
    root.classList.toggle('prd-RangeProducts--end', !canScroll || swiper.isEnd)
  }

  const reveal = (root) => {
    const swiper = root.querySelector('s-carousel')?.carousel
    const track = root.querySelector('.swiper')
    if (!swiper || swiper.destroyed || !track?.classList.contains('swiper-initialized')) return false

    const update = () => sync(root, swiper)
    swiper.on('progress', update)
    swiper.on('resize', update)
    swiper.on('lock', update)
    swiper.on('unlock', update)
    // Show the row before Swiper measures it. While hidden it measures 0 wide and leaves every slide
    // full width, which painted as huge thumbnails until its resize observer caught up a frame later.
    root.classList.add('is-ready')
    swiper.update()
    update()
    return true
  }

  customElements.define(
    'range-products',
    class RangeProducts extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return
        this.dataset.bound = 'true'

        this.addEventListener('click', this.onClick)

        if (reveal(this)) return

        const track = this.querySelector('.swiper')
        if (!track) return

        const observer = new MutationObserver(() => {
          if (reveal(this)) observer.disconnect()
        })
        observer.observe(track, { attributes: true, attributeFilter: ['class'] })
      }

      onClick = (event) => {
        const link = event.target.closest('a.prd-RangeProducts_Link')
        if (!link || !this.contains(link)) return
        if (link.classList.contains('is-current') || link.getAttribute('aria-current') === 'page') {
          event.preventDefault()
          return
        }

        const href = link.getAttribute('href')
        const mainProduct = this.closest('main-product')
        const productOpt = mainProduct?.querySelector('product-opt')
          || (customElements.get('product-opt') ? document.createElement('product-opt') : null)
        if (!href || !mainProduct || typeof productOpt?.renderProduct !== 'function') return

        event.preventDefault()
        if (productOpt.getAttribute('aria-busy') === 'true') return

        productOpt.saveSelectedSize()
        productOpt.renderProduct(href, mainProduct)
      }
    },
  )
}
